<template>
    <div :class="col + ' component-kira-select'">
        <div class="form-group mb-3">
            <label :for="id">
                <p class="mb-0 text-wrap">
                    {{title}}
                </p>
            </label>
            <div class="container">
                <input type="text"
                    hidden
                    class="form-control"
                    :id="id"
                    :name="name"
                    :disabled="disabled"
                    data-width="100%"
                    :value="checkData"
                    @change="$emit('input', checkData)"
                    data-toggle="toggle"
                    :data-on="capitalize(textOn)" :data-off="capitalize(textOff)"
                    :data-onstyle="color ? color : 'outline-secondary'"
                    :data-offstyle="coloroff ? coloroff : 'outline-secondary'">
            </div>
        </div>
    </div>
</template>

<script>
import bootstrapToggle from 'bootstrap4-toggle';
export default {
    props: [
        'id',
        'value',
        'title',
        'name',
        'expanded',
        'color',
        'coloroff',
        'on',
        'off',
        'disabled'
    ],
    data() { return {
        col: 'col-xs-12 col-md-6 col-lg-4',
        checkData: 'no',
        textOn:'si',
        textOff: 'no',
        values: [0,1]
    }},
    mounted() {
        const vm = this;
        const check = $('#'+this.id);
        if (this.on){
            this.textOn = this.on
        }
        if (this.off){
            this.textOff = this.off
        }
        this.checkData = this.value === this.textOn ? this.textOn : this.textOff

        if(this.expanded && this.expanded == 'true') {
            this.col = 'col-12';
        }
        this.changeCheckOptions(this.checkData)
        check.parent().on('click', function() {
            vm.checkData = vm.checkData === vm.textOn ? vm.textOff : vm.textOn
            vm.$emit('input', vm.checkData);
        });
        //this.$emit('input', false);

        /* if(this.value == undefined) {
            this.$emit('input', vm.checked ? true : false);
            if(vm.checked) {
                check.click();
            }
        }

        check.change(function() {
            console.log('cambios');
            if(vm.value == 'si') {
                vm.$emit('input', true);
            }

        });
 */
        /* vm.$on('cambia', function(valor) {
            if(valor == 'si') {
                check.parent().click();
                //vm.$emit('input', true);
            }
        });

        check.change(function() {
            console.log('cambios');
            vm.$emit('input', !vm.value);
        }); */

    },
    methods: {
        changeCheckOptions (val) {
            const check = $('#'+this.id);
            switch (val) {
                case this.textOff:
                    check.bootstrapToggle('off')
                    break;
                case this.textOn:
                    check.bootstrapToggle('on')
                    break;
                default:
                    check.bootstrapToggle('off')
                    break;
            }
        },
        capitalize (value) {
            if (!value) return ''
            value = value.toString()
            const arr = value.split(' ')
            const capitalized_array = []
            arr.forEach((word) => {
            const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
            capitalized_array.push(capitalized)
            })
            return capitalized_array.join(' ')
        }
    },
    watch: {
        value(val){
            this.checkData = val === this.textOn ? this.textOn : this.textOff
            this.changeCheckOptions(val)
        }
    }
}
</script>
